import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import mapStore from '../../../store/mapStore.ts'

let directionsService: any
let directionsRenderer: any

export const Directions: React.FC = () => {
    const map = mapStore(s => s.map)
    const myPosition = mapStore(s => s.myPosition)
    const directionsTo: google.maps.LatLng | null = mapStore(s => s.directionsTo)
    const travelMode = mapStore(s => s.travelMode)
    const [show, setShow] = React.useState(false)

    const [, updateState] = React.useState<any>();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    React.useEffect(() => {
        if (!directionsService) {
            directionsService = new google.maps.DirectionsService()
        }
        if (!directionsRenderer) {
            directionsRenderer = new window.google.maps.DirectionsRenderer()
        }
        return (() => {
            setTimeout(() => onClose())
        })
    }, [])

    React.useEffect(() => {
        if (map) {
            directionsRenderer.setMap(map)
            directionsRenderer.setPanel(document.getElementById('directions-panel'))
        }
    }, [map])

    const doRoute = (myPosition: google.maps.LatLng, directionsTo: google.maps.LatLng) => {
        directionsRenderer.setMap(null)
        if (map) {
            setTimeout(() => {
                directionsService = new google.maps.DirectionsService()
                directionsRenderer = new window.google.maps.DirectionsRenderer()
                directionsRenderer.setMap(map)
                directionsRenderer.setPanel(document.getElementById('directions-panel'))
                setTimeout(() => {
                    directionsRenderer.setMap(map)
                    const listener = window.google.maps.event.addListener(map, 'idle', () => {
                        const zoom = map?.getZoom()
                        mapStore.getState().setZoom(zoom!)
                        window.google.maps.event.removeListener(listener)
                    })
                    directionsService?.route({
                        origin: myPosition,
                        destination: directionsTo,
                        avoidTolls: true,
                        avoidHighways: true,
                        travelMode: travelMode
                    }, function (response: any, status: google.maps.DirectionsStatus) {
                        if (status == google.maps.DirectionsStatus.OK) {
                            if (document.getElementById('directions-panel')) {
                                directionsRenderer.setDirections(response)
                                setShow(true)
                            }
                        } else {
                            window.alert('Directions are not available')
                            onClose()
                        }
                    })
                })
            })
        }
    }
    const onClose = () => {
        mapStore.getState().setDirectionsTo(null)
        mapStore.getState().setTravelMode(null as any)
        directionsRenderer.setMap(null)
        const node = document.getElementById('directions-panel')
        if (node) {
            node.innerHTML = ''
        }
        setShow(false)
    }

    React.useEffect(() => {
        if (myPosition && directionsTo && travelMode) {
            directionsRenderer.setMap(null)
            directionsRenderer.setPanel(null)
            forceUpdate()
            doRoute(myPosition, directionsTo)
        }
    }, [myPosition, directionsTo])

    const controls = (
        <div id='directions-header' className={'w-full flex flex-row justify-between bg-primary text-primary-content'}>
            <div className={'px-2'}>
                <h4 className={'mb-0'}>{travelMode} Directions</h4>
            </div>
            <div
                className={'px-2 cursor-pointer'}
                onClick={() => onClose()}>
                <FontAwesomeIcon icon={faClose} fontSize={'medium'}/>
            </div>
        </div>
    )
    return (
        <div
            className={`${show ? 'inline-block' : 'hidden'} absolute top-[8px] left-[25vw] w-[50vw] z-47 bg-primary-content`}
            style={{zIndex: 1}}
        >
            {controls}
            <div id="directions-panel"/>
        </div>
    )
}
